import React, {useEffect, useState } from "react";
import { getTownhalls, createTownhall, getOrganizations } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertError, alertSuccess } from "../../utils/alerts";
import moment from "moment";

const INIT_STATE = {
    organization: null,
    title: null,
    description: null,
    date: null,
    time:null,
    year:"",
    meeting_link: "",
};

export default function OutsourcingLearning() {
    const [loading, setLoading] = useState(false);
    const [townhalls, setTownhalls] = useState(null);
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const [date] = useState(new Date());
    const [time] = useState(new Date());
    const [orgs, setOrgs] = useState([]);
    const [document, setDocumentFile] = useState("");

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setLoading(true);
        getTownhalls()
            .then((res) => { 
                setTownhalls(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        getOrganizations()
            .then((res) => {
                setOrgs(res.data.data);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
            });
    }, []);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            year: (date && moment(date).format("YYYY")) || "",
            month: (date && moment(date).format("MMMM")) || "",
            date: (date && moment(date).format("DD/MM/YYYY")) || "",
            time: (time && moment(time).format("h:mm:ss a")) || "",
        }));
    }, [date, time]); 
    
    useEffect(() => {
        setState((prev) => ({
            ...prev,
            document: document,
        }));
    }, [document]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
        };
        setLoading(true);
        createTownhall(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
    };

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    return (
        <>
            <h1 className="dash-title">Outsourcing</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Learning and Development</div>
                            <div className="spur-card-menu">
                                <button data-toggle="modal" style={{backgroundColor:"#fcce0d", color:"#444", border:'1px solid #fcce0d', fontWeight:'bold'}} 
                                    data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && townhalls && townhalls) ? 
                                    <div className="table-responsive">
                                        {(townhalls && townhalls.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Organization</th><th>Title</th><th>Year</th><th>Month</th><th>Date</th><th>Time</th>
                                            <th>Status</th><th>View</th></tr></thead>
                                            <tbody>
                                                {townhalls && townhalls.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.organization?.name && row?.organization?.name}</td>
                                                        <td>{row?.title && row?.title}</td>
                                                        <td>{row?.year && row?.year}</td>
                                                        <td>{row?.month && row?.month}</td>
                                                        <td>{row?.date && row?.date}</td>
                                                        <td>{row?.time && row?.time}</td> 
                                                        <td>{(row?.status === "draft" || row?.status === "disapproved") ? 
                                                        <span className="badge badge-warning">{row.status}</span> : 
                                                        <span className="badge badge-success">{row.status}</span>}</td>
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/outsourcing/townhall", row._id)} 
                                                                className='btn btn-preview'
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">SCHEDULE TOWN HALL MEETING</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Organization <span>*</span></label>
                                    <select className="form-control form-select" name="organization" id="organization" required  
                                    onChange={handleChange} defaultValue={state.organization} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {orgs && orgs.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Title of Townhall Meeting <span>*</span></label>
                                    <input type="text" name="title" className="form-control" required placeholder="Title of Townhall Meeting" 
                                     onChange={handleChange} defaultValue={state.title && state.title }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Date of Townhall Meeting <span>*</span></label>
                                    <input type="date" name="date" className="form-control" required placeholder="Date of Townhall Meeting" 
                                     onChange={handleChange} defaultValue={state.date && state.date }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Time of Townhall Meeting <span>*</span></label>
                                    <input type="time" name="time" className="form-control" required placeholder="Time of Townhall Meeting" 
                                     onChange={handleChange} defaultValue={state.time && state.time }  disabled={loading} />
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Document <span>*</span></label>
                                    <input type="file" name="document" className="form-control" required placeholder="Document" disabled={loading}
                                        onChange={(e) => {setDocumentFile(e.target.files[0]);}} 
                                    />
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Short Description of Meeting <span>*</span></label>
                                    <textarea cols="33" rows="3" name="description" className="form-control" required 
                                        placeholder="Short Description of Meeting"
                                         onChange={handleChange} defaultValue={state.description && state.description}  disabled={loading}></textarea>
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Meeting Link <span>*</span></label>
                                    <input type="text" name="meeting_link" className="form-control" required placeholder="Meeting Link" 
                                     onChange={handleChange} defaultValue={state.meeting_link && state.meeting_link }  disabled={loading} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create Meeting</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
